module.exports = __webpack_public_path__ + "static/media/secteur.293be687.png";